/**
 * Joins CSS Module class names.
 *
 * Exists because `styles.foo` is typed `string | undefined` under
 * `noUncheckedIndexedAccess`, which strict component props reject. Written here rather
 * than pulled from a package — joining strings is not worth a dependency (skill 3.1).
 */
export function cx(...classNames: Array<string | false | null | undefined>): string {
  return classNames.filter(Boolean).join(' ');
}
